import { Alert, Snackbar } from '@mui/material'

const SnackbarModal = ({open = false, onClose = null, severity = 'error', message = null}) => {
  return (
    <Snackbar
        open={open} 
        onClose={onClose} 
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={10000}
    >
        <Alert onClose={onClose}  severity={severity}>
            {message}
        </Alert>
    </Snackbar>
  )
}

export default SnackbarModal